export default {
  nav: {
    home: 'Home',
    about: 'About Us',
    products: 'Products',
    news: 'News',
    contact: 'Contact'
  },
  brand: {
    name: 'Linyi Wini Best Trading Co., Ltd'
  },
  lang: {
    zh: '中文',
    en: 'English'
  },
  contact: {
    phone: '+86 151639',
    email: 'postmaster5@lyyllb.com'
  },
  home: {
    heroTitle: 'Linyi Wini Best Trading Co., Ltd',
    heroSubtitle: 'Professional · Focused · Serving Customers',
    introTitle: 'Professional, Focused, Serving Customers',
    introDesc: 'Linyi Wini Best Trading Co., Ltd is located in Linyi City, Shandong Province, China. With convenient transportation and superior geographical location, we have been committed to providing customers with the most excellent value services as a creative and rapidly growing company.',
    introDetail: 'We are an integrated production and sales enterprise with over 20 sets of production equipment, covering an area of 15 acres, and a warehouse storage capacity of 2000 square meters. We specialize in producing auto-darkening welding helmets, handheld welding masks, plastic face shields, various types of safety goggles and other labor protection products.',
    introFeatures: {
      equipment: '20+ Production Equipment',
      area: '15 Acres Factory Area',
      warehouse: '2000m² Warehouse'
    },
    stats: {
      founded: 'Founded in',
      employees: 'Employees',
      area: 'Area',
      exports: 'Annual Exports'
    },
    advantages: {
      direct: {
        title: 'Factory Direct Sales',
        desc: 'Located in Linyi City, Shandong Province, near Qingdao Port. Factory wholesale prices with maximum discounts. Most products have no minimum order quantity.',
        features: {
          '1': 'Wholesale Price',
          '2': 'Flexible MOQ',
          '3': 'Convenient Logistics'
        }
      },
      custom: {
        title: 'Customization',
        desc: 'Your logo, packaging printing, and colorful decal designs can be customized. We try our best to meet your requirements. Currently, we have more than 20 different color decal models for auto-darkening welding helmets.',
        features: {
          '1': 'Logo Custom',
          '2': 'Packaging Custom',
          '3': '20+ Decals'
        }
      },
      quality: {
        title: 'Quality Assurance',
        desc: 'We have our own professional quality control team. Every product undergoes professional and detailed quality inspection before leaving the factory.',
        features: {
          '1': 'QC Team',
          '2': 'Pre-shipment Inspection',
          '3': 'Quality Certifications'
        }
      },
      delivery: {
        title: 'On-Time Delivery',
        desc: 'We accept flexible delivery methods, including LCL and direct delivery to your designated warehouse. We guarantee timely delivery.',
        features: {
          '1': 'Flexible Shipping',
          '2': 'LCL Service',
          '3': 'On-Time Delivery'
        }
      }
    },
    news: {
      title: 'Latest News',
      subtitle: 'Stay updated with our latest news and industry insights',
      readMore: 'Read More',
      viewAll: 'View All',
      items: {
        1: {
          title: 'Don\'t let "bare welding" be a weapon that harms your eyes!',
          excerpt: 'The welding process produces intense arc light, large amounts of harmful gases, and varying degrees of molten metal splashes...',
          month: 'Sep'
        },
        2: {
          title: 'Pros and cons of different welding masks for face protection',
          excerpt: 'Welding masks are labor protection equipment used to protect the face during electrical welding, metal cutting, and welding operations...',
          month: 'Sep'
        },
        3: {
          title: 'Which welding mask is best?',
          excerpt: 'Arc light, UV and IR rays harm the eyes. Therefore, professional welders should use auto-darkening welding helmets...',
          month: 'Sep'
        }
      }
    },
    products: {
      title: 'Featured Products',
      subtitle: 'High-quality protective equipment for welding safety',
      viewMore: 'View All Products',
      hot: 'Hot',
      popular: 'Popular'
    },
    factory: {
      title: 'Factory Display',
      subtitle: 'Witness the power of professionalism and quality'
    },
    cta: {
      title: 'Need more product information?',
      text: 'Our professional team is ready to serve you, providing the best products and professional consultation',
      contact: 'Contact Now'
    },
    scrollDown: 'Scroll Down',
    introBadge: 'Professional Service',
    readMore: 'Learn More',
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch for inquiries and quotes',
      phone: 'Phone',
      email: 'Email',
      address: 'Address'
    }
  },
  about: {
    introTag: 'Company Profile',
    introTitle: 'Linyi Wini Best Trading Co., Ltd',
    introSubtitle: 'Professional, Focused, Serving Customers',
    introDesc: 'Linyi Wini Best Trading Co., Ltd is located in Linyi City, Shandong Province, China. With convenient transportation and superior geographical location, we have been committed to providing customers with the most excellent value services as a creative and rapidly growing company.',
    introDesc2: 'Our company is an integrated production and sales enterprise with more than 20 production equipment sets, covering 15 acres of factory area, and 2000 square meters of warehouse storage. We specialize in producing auto-darkening welding helmets, handheld welding masks, plastic protective face shields, various types of goggles, and other labor protection products.',
    experience: 'Years Experience',
    advantages: {
      title: 'Why Choose Us',
      subtitle: 'Professional quality, trustworthy',
      direct: {
        title: 'Factory Direct Sales',
        desc: 'Located in Linyi City, Shandong Province, near Qingdao Port. Factory wholesale prices with maximum discounts. Most products have no minimum order quantity.',
        features: {
          '1': 'Wholesale Price',
          '2': 'Flexible MOQ',
          '3': 'Convenient Logistics'
        }
      },
      custom: {
        title: 'Customization',
        desc: 'Your logo, packaging printing, and colorful decal designs can be customized. We try our best to meet your requirements. Currently, we have more than 20 different color decal models for auto-darkening welding helmets.',
        features: {
          '1': 'Logo Custom',
          '2': 'Packaging Custom',
          '3': '20+ Decals'
        }
      },
      quality: {
        title: 'Quality Assurance',
        desc: 'We have our own professional quality control team. Every product undergoes professional and detailed quality inspection before leaving the factory.',
        features: {
          '1': 'QC Team',
          '2': 'Pre-shipment Inspection',
          '3': 'Quality Certifications'
        }
      },
      delivery: {
        title: 'On-Time Delivery',
        desc: 'We accept flexible delivery methods, including LCL and direct delivery to your designated warehouse. We guarantee timely delivery.',
        features: {
          '1': 'Flexible Shipping',
          '2': 'LCL Service',
          '3': 'On-Time Delivery'
        }
      }
    },
    timeline: {
      title: 'Company Development',
      subtitle: 'From a small workshop to a professional enterprise',
      founded: 'Company Founded',
      foundedDesc: 'Linyi Wini Best Trading Co., Ltd was officially established, embarking on the road of entrepreneurship',
      expansion: 'Scale Expansion',
      expansionDesc: 'Introduced advanced production equipment, expanded production scale',
      innovation: 'Product Innovation',
      innovationDesc: 'Launched independently developed auto-darkening welding helmet product line',
      market: 'Market Expansion',
      marketDesc: 'Started expanding overseas markets, products exported to multiple countries',
      modernization: 'Modernization Upgrade',
      modernizationDesc: 'Completed factory modernization transformation, introduced intelligent production lines',
      development: 'Continuous Development',
      developmentDesc: 'Continuous innovation, providing customers with better products and services'
    },
    stats: {
      title: 'Company Strength',
      subtitle: 'Years of experience and accumulation',
      founded: 'Founded in',
      employees: 'Employees',
      area: 'Area',
      exports: 'Annual Exports'
    },
    features: {
      factory: {
        title: 'Own Factory',
        desc: '15 acres modern factory'
      },
      equipment: {
        title: 'Advanced Equipment',
        desc: '20+ production equipment'
      },
      storage: {
        title: 'Sufficient Stock',
        desc: '2000m² warehouse'
      }
    },
    factory: {
      title: 'Factory Display',
      subtitle: 'Advanced production equipment, professional production team',
      viewLarge: 'View Large'
    },
    cta: {
      title: 'Looking forward to cooperating with you',
      text: 'Whether you are looking for products or cooperation opportunities, we warmly welcome your inquiries'
    }
  },
  products: {
    categories: {
      weldingGlasses: 'Welding Glasses',
      safetyGlasses: 'Safety Glasses',
      weldingMask: 'Welding Masks',
      protectiveGear: 'Protective Gear'
    },
    categoryDesc: {
      weldingGlasses: 'Professional welding protection glasses, multiple specifications available, protecting welders\' eyes from UV and IR rays',
      safetyGlasses: 'Universal safety glasses, suitable for various work scenarios, effectively protecting eye safety',
      weldingMask: 'Welding mask series, providing comprehensive facial protection including handheld and helmet types',
      protectiveGear: 'Other protective equipment including gloves, masks, helmets, etc., providing comprehensive protection for workers'
    },
    pageTitle: 'Product Center',
    pageSubtitle: 'High-quality labor protection products for all your needs',
    listTitle: 'Product List',
    hot: 'Hot',
    viewDetail: 'View Details',
    contactUs: 'Contact Us',
    emptyTitle: 'No Products',
    emptyDesc: 'No products in this category, please select another category',
    features: {
      title: 'Why Choose Us',
      subtitle: 'Our Advantages',
      items: {
        quality: {
          title: 'Quality Certification',
          desc: 'All products pass ISO quality certification'
        },
        shipping: {
          title: 'Fast Shipping',
          desc: 'Adequate stock, ship immediately upon order'
        },
        support: {
          title: 'Technical Support',
          desc: 'Professional technical team provides support'
        },
        service: {
          title: 'After-sales Service',
          desc: 'Complete after-sales service system'
        }
      }
    },
    cta: {
      title: 'Need Custom Products?',
      desc: 'We provide OEM/ODM services, supporting customization of logo, packaging, color decals, etc.'
    },
    modal: {
      specs: 'Product Features:',
      contactUs: 'Get Quote'
    },
    items: {
      1: {
        name: 'Welding Glasses',
        desc: 'Professional welding protection, UV and IR blocking, protecting welders\' eyes',
        specs: {
          0: 'UV400 Protection',
          1: 'Splash Proof',
          2: 'Lightweight & Comfortable',
          3: 'Clear Vision'
        }
      },
      2: {
        name: 'Welding Glasses',
        desc: 'Dark lens design, professional welding use, effectively blocking strong light',
        specs: {
          0: 'Dark Lens',
          1: 'Strong Light Blocking',
          2: 'Scratch Resistant Coating',
          3: 'Adjustable'
        }
      },
      3: {
        name: 'Welding Glasses',
        desc: 'Comfortable lightweight design, no pressure for long-time wear',
        specs: {
          0: 'Lightweight Design',
          1: 'Ergonomic',
          2: 'Good Ventilation',
          3: 'Durable Material'
        }
      },
      4: {
        name: 'Welding Glasses',
        desc: 'Professional grade protection, suitable for high-frequency welding operations',
        specs: {
          0: 'Professional Grade Lens',
          1: 'High-frequency Welding',
          2: 'Comprehensive Protection',
          3: 'High Transmittance'
        }
      }
    }
  },
  news: {
    pageTitle: 'News & Information',
    pageSubtitle: 'Latest news and industry insights',
    search: 'Search news...',
    categories: {
      all: 'All',
      safety: 'Safety Knowledge',
      product: 'Product News',
      industry: 'Industry News',
      other: 'Other'
    },
    tags: {
      safety: 'Welding Safety',
      glasses: 'Safety Glasses',
      helmet: 'Welding Helmet',
      labor: 'Labor Protection',
      industry: 'Industry Trends',
      quality: 'Product Quality',
      knowledge: 'Safety Knowledge'
    },
    readMore: 'Read More',
    viewDetail: 'View Details',
    emptyTitle: 'No News',
    emptyDesc: 'Please try other search keywords or categories',
    pagination: {
      total: 'Total',
      articles: 'articles'
    },
    sidebar: {
      contact: 'Contact Us',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      addressValue: 'Linyi City, Shandong Province',
      contactForm: 'Contact Form',
      popular: 'Popular Posts',
      categories: 'Categories'
    },
    modal: {
      share: 'Share to:',
      views: 'views'
    },
    articles: {
      1: {
        title: 'Don\'t let "Naked Welding" be the weapon that hurts your father!',
        excerpt: 'During welding, intense arc light, harmful gases, and metal splashes are produced. The arc light contains strong ultraviolet (UV), infrared (IR), and visible light, which is why arc light damages eyes.',
        content: 'Welding is a high-risk job. Without proper protection, it can cause serious threats to workers\' health. The eyes are the most vulnerable part. Ultraviolet rays from welding can burn the cornea, infrared rays can cause cataracts, and the strong visible light can temporarily affect vision...'
      },
      2: {
        title: 'Advantages and Disadvantages of Different Welding Masks for Face Protection',
        excerpt: 'Choosing the right welding mask is crucial for protecting welders\' safety. This article compares several common types of welding masks to help you make an informed decision.',
        content: 'When choosing a welding mask, factors such as protection level, comfort, and ease of use need to be considered. This article will compare different types of welding masks, including handheld masks, fixed masks, and auto-darkening masks...'
      },
      3: {
        title: 'Which Welding Mask is Best?',
        excerpt: 'With so many welding mask options on the market, how do you choose the right one? This article provides a comprehensive guide to help you select the best welding mask for your needs.',
        content: 'The choice of welding mask depends on factors such as the type of welding, working environment, and personal preferences. Auto-darkening welding helmets are becoming increasingly popular due to their convenience and safety features...'
      },
      4: {
        title: 'Importance of Eye Protection in Welding Work',
        excerpt: 'Eye protection is one of the most important aspects of welding safety. This article explains why wearing proper eye protection is essential for welders.',
        content: 'Welding produces intense light and harmful radiation that can cause permanent eye damage. Proper welding goggles or helmets with appropriate shade levels are essential for protecting the eyes...'
      },
      5: {
        title: 'New Safety Standards for Welding Protective Equipment',
        excerpt: 'New safety standards for welding protective equipment have been released, raising the requirements for product quality and protection levels.',
        content: 'The new standards require welding protective equipment to meet higher safety performance requirements, including better UV/IR protection, impact resistance, and flame retardancy...'
      },
      6: {
        title: 'How to Properly Maintain Your Welding Helmet',
        excerpt: 'Proper maintenance of your welding helmet can extend its service life and ensure optimal protection. This article provides tips for maintaining your welding equipment.',
        content: 'Regular cleaning, inspection, and replacement of worn parts are essential for maintaining the performance of your welding helmet. Proper storage when not in use can also prevent damage...'
      },
      7: {
        title: 'Summer Welding Safety Tips',
        excerpt: 'Welding in hot weather presents additional challenges. This article provides safety tips for welding in summer conditions.',
        content: 'High temperatures can affect both the welder\'s comfort and the performance of equipment. Proper hydration, ventilation, and heat-resistant clothing are essential...'
      },
      8: {
        title: 'New Protective Glasses Launched',
        excerpt: 'Linyi Wini Best Trading Co., Ltd introduces a new generation of protective glasses with new anti-fog materials for clearer vision and more comfortable wearing.',
        content: 'We are pleased to announce the official launch of our newly developed protective glasses. This product uses revolutionary anti-fog coating technology that keeps lenses clear even in humid environments...'
      }
    }
  },
  contact: {
    pageTitle: 'Contact Us',
    pageSubtitle: 'Get in touch with us for inquiries and quotes',
    info: {
      address: {
        title: 'Company Address',
        value: 'Linyi City, Shandong Province',
        label: 'Welcome to visit'
      },
      phone: {
        title: 'Phone',
        label: '24-hour service hotline'
      },
      email: {
        title: 'Email',
        label: 'Response during working hours'
      },
      whatsapp: {
        title: 'WhatsApp',
        label: 'Quick inquiry'
      }
    },
    form: {
      title: 'Send Inquiry',
      subtitle: 'Fill out the form below and we will contact you within 24 hours',
      name: 'Name',
      namePlaceholder: 'Please enter your name',
      phone: 'Phone',
      phonePlaceholder: 'Please enter your phone number',
      email: 'Email',
      emailPlaceholder: 'Please enter your email address',
      company: 'Company',
      companyPlaceholder: 'Please enter your company name',
      subject: 'Subject',
      subjectPlaceholder: 'Please select subject',
      subjectOptions: {
        product: 'Product Inquiry',
        quote: 'Price Quote',
        cooperation: 'Cooperation',
        feedback: 'Feedback',
        other: 'Other'
      },
      message: 'Message',
      messagePlaceholder: 'Please enter your message, such as products you are interested in, expected price range, contact information, etc.',
      submit: 'Submit Inquiry',
      submitting: 'Submitting...',
      reset: 'Reset',
      success: 'Submission Successful!',
      successMsg: 'Thank you for your inquiry. We will contact you within 24 hours.'
    },
    map: {
      title: 'Visit Address',
      companyName: 'Linyi Wini Best Trading Co., Ltd',
      address: 'Linyi City, Shandong Province'
    }
  },
  footer: {
    logo: 'Wini Best Trading',
    desc: 'We specialize in providing one-stop services covering various labor protection products to meet your diverse needs, including: safety glasses, plastic face shields, welding masks, welding helmets (especially different styles of auto-darkening welding helmets), safety helmets, and other related welding tools.',
    links: {
      title: 'Quick Links',
      items: {
        home: 'Home',
        about: 'About Us',
        products: 'Products',
        news: 'News',
        contact: 'Contact Us'
      }
    },
    products: {
      title: 'Products',
      items: {
        helmet: 'Auto-darkening Welding Helmet',
        glasses: 'Welding Glasses',
        shield: 'Plastic Face Shield',
        mask: 'Handheld Welding Mask',
        goggles: 'Safety Goggles'
      }
    },
    contact: {
      title: 'Contact Us',
      address: 'Address',
      addressValue: 'Linyi City, Shandong Province',
      phone: 'Phone',
      email: 'Email'
    },
    newsletter: {
      title: 'Newsletter',
      desc: 'Subscribe to our latest updates and promotions',
      placeholder: 'Enter your email address',
      subscribe: 'Subscribe',
      success: 'Thank you for subscribing! We will send you the latest news regularly.'
    },
    copyright: {
      company: 'Linyi Wini Best Trading Co., Ltd',
      reserved: 'All rights reserved'
    },
    badges: {
      quality: 'Quality Assurance',
      delivery: 'On-time Delivery',
      support: '24/7 Support'
    }
  }
}
